import { render } from "./ServiceNameSelect.vue?vue&type=template&id=60beccb2"
import script from "./ServiceNameSelect.vue?vue&type=script&lang=js"
export * from "./ServiceNameSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__